import { render, staticRenderFns } from "./Supply-and-demand-hall.vue?vue&type=template&id=779e4cf5&scoped=true&"
import script from "./Supply-and-demand-hall.vue?vue&type=script&lang=js&"
export * from "./Supply-and-demand-hall.vue?vue&type=script&lang=js&"
import style0 from "./Supply-and-demand-hall.vue?vue&type=style&index=0&id=779e4cf5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779e4cf5",
  null
  
)

export default component.exports